<template>
  <section id="category-trends">
    <article>
      <div class="row clearfix">
        <h1>
          Category Trends
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <p class="text-center">
          This section presents an analysis for each of the 12 event categories as defined in
          <router-link :to="{name: 'Appendix'}">the Appendix</router-link>
        </p>
      </div>
    </article>
    <figure class="chart">
      <div class="row clearfix">
        <div class="chart-wrapper">
          <highcharts v-if="categoryTrends" class="graphcontainer" :options="categoryTrends"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>LEGENDS (of the Golden Arches)</em>, Performing Lines presented at the 2025 Perth International Arts Festival, Photo Credit: Jessica Wyld</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data() {
    return {
      activeYear: 2025,
      years: [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
      reports: [
        {
          year: 2025,
          revenue: [
            ['Ballet and Dance', 2.1],
            ['Children\'s/Family', 2.1],
            ['Classical Music', 4.0],
            ['Comedy', 3.9],
            ['Circus and Physical Theatre', 1.9],
            ['Festivals (Multi-Category)', 2.8],
            ['Musical Theatre', 13.2],
            ['Contemporary Music', 53.5],
            ['Opera', 1.4],
            ['Festivals (Contemporary Music)', 11.9],
            ['Special Events', 0.2],
            ['Theatre', 3.0],
          ],
          attendance: [
            ['Ballet and Dance', 2.3],
            ['Children\'s/Family', 5.8],
            ['Classical Music', 4.8],
            ['Comedy', 7.1],
            ['Circus and Physical Theatre', 2.4],
            ['Festivals (Multi-Category)', 8.0],
            ['Musical Theatre', 11.9],
            ['Contemporary Music', 44.8],
            ['Opera', 1.2],
            ['Festivals (Contemporary Music)', 6.9],
            ['Special Events', 0.8],
            ['Theatre', 4.1],
          ],
        },
        {
          year: 2024,
          revenue: [
            ['Ballet and Dance', 2.2],
            ['Children\'s/Family', 2.3],
            ['Circus and Physical Theatre', 0.7],
            ['Classical Music', 3.1],
            ['Comedy', 5.1],
            ['Contemporary Music', 54.0],
            ['Festivals (Multi-Category)', 2.5],
            ['Festivals (Contemporary Music)', 9.9],
            ['Musical Theatre', 15.9],
            ['Opera', 0.9],
            ['Special Events', 0.3],
            ['Theatre', 3.1],
          ],
          attendance: [
            ['Ballet and Dance', 2.3],
            ['Children\'s/Family', 6.0],
            ['Circus and Physical Theatre', 1.2],
            ['Classical Music', 4.4],
            ['Comedy', 7.7],
            ['Contemporary Music', 44.8],
            ['Festivals (Multi-Category)', 7.1],
            ['Festivals (Contemporary Music)', 6.4],
            ['Musical Theatre', 13.9],
            ['Opera', 0.9],
            ['Special Events', 0.8],
            ['Theatre', 4.4],
          ],
        },
        {
          year: 2023,
          revenue: [
            ['Ballet and Dance', 2.2],
            ['Children\'s/Family', 2.2],
            ['Circus and Physical Theatre', 2.2],
            ['Classical Music', 2.9],
            ['Comedy', 6.3],
            ['Contemporary Music', 47.4],
            ['Festivals (Multi-Category)', 2.9],
            ['Festivals (Contemporary Music)', 11.3],
            ['Musical Theatre', 17.3],
            ['Opera', 1.3],
            ['Special Events', 0.1],
            ['Theatre', 3.9],
          ],
          attendance: [
            ['Ballet and Dance', 2.7],
            ['Children\'s/Family', 5.7],
            ['Circus and Physical Theatre', 2.3],
            ['Classical Music', 4.3],
            ['Comedy', 9.6],
            ['Contemporary Music', 39.9],
            ['Festivals (Multi-Category)', 8.0],
            ['Festivals (Contemporary Music)', 6.7],
            ['Musical Theatre', 14.3],
            ['Opera', 1.1],
            ['Special Events', 0.6],
            ['Theatre', 4.8],
          ],
        },
        {
          year: 2022,
          revenue: [
            ['Ballet and Dance', 3.2],
            ['Children\'s/Family', 2.4],
            ['Circus and Physical Theatre', 1.1],
            ['Classical Music', 4.4],
            ['Comedy', 5.7],
            ['Contemporary Music', 35.2],
            ['Festivals (Multi-Category)', 3.5],
            ['Festivals (Contemporary Music)', 11.7],
            ['Musical Theatre', 25.9],
            ['Opera', 1.2],
            ['Special Events', 0.2],
            ['Theatre', 5.5],
          ],
          attendance: [
            ['Ballet and Dance', 3.1],
            ['Children\'s/Family', 6.1],
            ['Circus and Physical Theatre', 1.3],
            ['Classical Music', 4.9],
            ['Comedy', 8.8],
            ['Contemporary Music', 35.9],
            ['Festivals (Multi-Category)', 8.8],
            ['Festivals (Contemporary Music)', 6.3],
            ['Musical Theatre', 17.6],
            ['Opera', 0.9],
            ['Special Events', 0.6],
            ['Theatre', 5.6],
          ],
        },
        {
          year: 2021,
          revenue: [
            ['Ballet and Dance', 4.0],
            ['Children\'s/Family', 5.1],
            ['Classical Music', 5.6],
            ['Festivals (Multi-Category)', 5.6],
            ['Festivals (Contemporary Music)', 7.6],
            ['Musical Theatre', 29.8],
            ['Contemporary Music', 21.4],
            ['Opera', 2.3],
            ['Special Events', 0.4],
            ['Theatre', 7.9],
            ['Circus and Physical Theatre', 3.1],
            ['Comedy', 7.4]
          ],
          attendance: [
            ['Ballet and Dance', 3.3],
            ['Children\'s/Family', 9.7],
            ['Classical Music', 5.5],
            ['Festivals (Multi-Category)', 14.3],
            ['Festivals (Contemporary Music)', 4.2],
            ['Musical Theatre', 16.4],
            ['Contemporary Music', 25.1],
            ['Opera', 1.4],
            ['Special Events', 0.7],
            ['Theatre', 6.1],
            ['Circus and Physical Theatre', 2.5],
            ['Comedy', 10.8]
          ],
        },
        {
          year: 2020,
          revenue: [
            ['Ballet and Dance', 1.2],
            ['Children\'s/Family', 1.7],
            ['Classical Music', 3.0],
            ['Festivals (Multi-Category)', 6.5],
            ['Festivals (Contemporary Music)', 8.9],
            ['Musical Theatre', 11.1],
            ['Contemporary Music', 51.0],
            ['Opera', 1.9],
            ['Special Events', 0.8],
            ['Theatre', 6.6],
            ['Circus and Physical Theatre', 3.7],
            ['Comedy', 3.5]
          ],
          attendance: [
            ['Ballet and Dance', 1.8],
            ['Children\'s/Family', 4.9],
            ['Classical Music', 3.7],
            ['Festivals (Multi-Category)', 20.2],
            ['Festivals (Contemporary Music)', 5.6],
            ['Musical Theatre', 9.4],
            ['Contemporary Music', 37.0],
            ['Opera', 1.9],
            ['Special Events', 2.1],
            ['Theatre', 5.4],
            ['Circus and Physical Theatre', 3.5],
            ['Comedy', 4.4]
          ],
        },
        {
          year: 2019,
          revenue: [
            ['Ballet and Dance', 3.4],
            ['Children\'s/Family', 2.2],
            ['Classical Music', 4.4],
            ['Festivals (Multi-Category)', 2.8],
            ['Festivals (Contemporary Music)', 9.2],
            ['Musical Theatre', 17.2],
            ['Contemporary Music', 42.5],
            ['Opera', 2.0],
            ['Special Events', 1.1],
            ['Theatre', 7.5],
            ['Circus and Physical Theatre', 2.4],
            ['Comedy', 5.3]
          ],
          attendance: [
            ['Ballet and Dance', 3.4],
            ['Children\'s/Family', 4.9],
            ['Classical Music', 5.5],
            ['Festivals (Multi-Category)', 9.1],
            ['Festivals (Contemporary Music)', 6.1],
            ['Musical Theatre', 14.5],
            ['Contemporary Music', 34.7],
            ['Opera', 1.8],
            ['Special Events', 1.8],
            ['Theatre', 6.4],
            ['Circus and Physical Theatre', 2.7],
            ['Comedy', 9.1]
          ],
        },
        {
          year: 2018,
          revenue: [
            ['Ballet and Dance', 3.0],
            ['Children\'s/Family', 2.8],
            ['Classical Music', 3.7],
            ['Festivals (Multi-Category)', 3.2],
            ['Festivals (Contemporary Music)', 4.7],
            ['Musical Theatre', 18.5],
            ['Contemporary Music', 50.5],
            ['Opera', 2.2],
            ['Special Events', 1.0],
            ['Theatre', 3.6],
            ['Circus and Physical Theatre', 1.1],
            ['Comedy', 5.8]
          ],
          attendance: [
            ['Ballet and Dance', 3.0],
            ['Children\'s/Family', 6.3],
            ['Classical Music', 4.8],
            ['Festivals (Multi-Category)', 9.8],
            ['Festivals (Contemporary Music)', 3.7],
            ['Musical Theatre', 14.9],
            ['Contemporary Music', 38.4],
            ['Opera', 1.9],
            ['Special Events', 0.6],
            ['Theatre', 5.4],
            ['Circus and Physical Theatre', 1.7],
            ['Comedy', 9.4]
          ],
        },
        {
          year: 2017,
          revenue: [
            ['Ballet and Dance', 3.3],
            ['Children\'s/Family', 2.7],
            ['Classical Music', 4.1],
            ['Festivals (Multi-Category)', 2.9],
            ['Festivals (Contemporary Music)', 5.3],
            ['Musical Theatre', 22.1],
            ['Contemporary Music', 43.8],
            ['Opera', 1.9],
            ['Special Events', 0.3],
            ['Theatre', 3.4],
            ['Circus and Physical Theatre', 6.2],
            ['Comedy', 3.8]
          ],
          attendance: [
            ['Ballet and Dance', 3.5],
            ['Children\'s/Family', 5.7],
            ['Classical Music', 5.7],
            ['Festivals (Multi-Category)', 8.1],
            ['Festivals (Contemporary Music)', 3.7],
            ['Musical Theatre', 17.6],
            ['Contemporary Music', 36.8],
            ['Opera', 1.6],
            ['Special Events', 0.6],
            ['Theatre', 6.3],
            ['Circus and Physical Theatre', 5.1],
            ['Comedy', 5.4]
          ],
        },
        {
          year: 2016,
          revenue: [
            ['Ballet and Dance', 4.2],
            ['Children\'s/Family', 3.8],
            ['Classical Music', 5.4],
            ['Festivals (Multi-Category)', 4.0],
            ['Festivals (Contemporary Music)', 5.6],
            ['Musical Theatre', 24.3],
            ['Contemporary Music', 30.8],
            ['Opera', 3.2],
            ['Special Events', 2.00],
            ['Theatre', 5.6],
            ['Circus and Physical Theatre', 5.1],
            ['Comedy', 6.0]
          ],
          attendance: [
            ['Ballet and Dance', 4.3],
            ['Children\'s/Family', 7.3],
            ['Classical Music', 6.5],
            ['Festivals (Multi-Category)', 8.2],
            ['Festivals (Contemporary Music)', 3.6],
            ['Musical Theatre', 17.6],
            ['Contemporary Music', 30.1],
            ['Opera', 2.2],
            ['Special Events', 1.0],
            ['Theatre', 7.2],
            ['Circus and Physical Theatre', 4.5],
            ['Comedy', 7.5]
          ],
        },
        {
          year: 2015,
          revenue: [
            ['Ballet and Dance', 4.5],
            ['Children\'s/Family', 2.7],
            ['Classical Music', 4.0],
            ['Festivals (Multi-Category)', 4.0],
            ['Festivals (Contemporary Music)', 7.6],
            ['Musical Theatre', 23.8],
            ['Contemporary Music', 34.0],
            ['Opera', 2.9],
            ['Special Events', 1.4],
            ['Theatre', 4.0],
            ['Circus and Physical Theatre', 7.1],
            ['Comedy', 3.9]
          ],
          attendance: [
            ['Ballet and Dance', 4.7],
            ['Children\'s/Family', 5.9],
            ['Classical Music', 5.4],
            ['Festivals (Multi-Category)', 6.7],
            ['Festivals (Contemporary Music)', 7.1],
            ['Musical Theatre', 17.7],
            ['Contemporary Music', 30.2],
            ['Opera', 2.4],
            ['Special Events', 3.0],
            ['Theatre', 6.2],
            ['Circus and Physical Theatre', 5.3],
            ['Comedy', 5.4]
          ],
        },
        {
          year: 2014,
          revenue: [
            ['Ballet and Dance', 3.5],
            ['Children\'s/Family', 2.9],
            ['Classical Music', 4.3],
            ['Festivals (Multi-Category)', 3.2],
            ['Festivals (Contemporary Music)', 8.6],
            ['Musical Theatre', 21.2],
            ['Contemporary Music', 40.1],
            ['Opera', 2.8],
            ['Special Events', 0.7],
            ['Theatre', 6.6],
            ['Circus and Physical Theatre', 3.1],
            ['Comedy', 3.0]
          ],
          attendance: [
            ['Ballet and Dance', 4.1],
            ['Children\'s/Family', 6.6],
            ['Classical Music', 5.5],
            ['Festivals (Multi-Category)', 5.7],
            ['Festivals (Contemporary Music)', 6.9],
            ['Musical Theatre', 17.2],
            ['Contemporary Music', 34.5],
            ['Opera', 2.1],
            ['Special Events', 1.1],
            ['Theatre', 8.1],
            ['Circus and Physical Theatre', 3.0],
            ['Comedy', 5.2]
          ],
        },
        {
          year: 2013,
          revenue: [
            ['Ballet and Dance', 4.2],
            ['Children\'s/Family', 2.6],
            ['Classical Music', 4.8],
            ['Festivals (Multi-Category)', 1.7],
            ['Festivals (Contemporary Music)', 7.3],
            ['Musical Theatre', 13.1],
            ['Contemporary Music', 42.5],
            ['Opera', 2.9],
            ['Special Events', 0.4],
            ['Theatre', 8.1],
            ['Circus and Physical Theatre', 9.6],
            ['Comedy', 2.8]
          ],
          attendance: [
            ['Ballet and Dance', 5.4],
            ['Children\'s/Family', 6.1],
            ['Classical Music', 6.5],
            ['Festivals (Multi-Category)', 4.4],
            ['Festivals (Contemporary Music)', 5.9],
            ['Musical Theatre', 11.6],
            ['Contemporary Music', 35],
            ['Opera', 1.9],
            ['Special Events', 0.6],
            ['Theatre', 10.3],
            ['Circus and Physical Theatre', 7.2],
            ['Comedy', 5.1]
          ],
        },
        {
          year: 2012,
          revenue: [
            ['Ballet and Dance', 4.8],
            ['Children\'s/Family', 4.3],
            ['Classical Music', 5.1],
            ['Festivals (Multi-Category)', 1.1],
            ['Festivals (Contemporary Music)', 8.2],
            ['Musical Theatre', 16.9],
            ['Contemporary Music', 40],
            ['Opera', 4],
            ['Special Events', 0.4],
            ['Theatre', 6.9],
            ['Circus and Physical Theatre', 4.5],
            ['Comedy', 4]
          ],
          attendance: [
            ['Ballet and Dance', 5.7],
            ['Children\'s/Family', 8],
            ['Classical Music', 7.7],
            ['Festivals (Multi-Category)', 1.6],
            ['Festivals (Contemporary Music)', 7.2],
            ['Musical Theatre', 13.7],
            ['Contemporary Music', 33.7],
            ['Opera', 2.6],
            ['Special Events', 0.6],
            ['Theatre', 9.8],
            ['Circus and Physical Theatre', 3.4],
            ['Comedy', 6]
          ],
        },
        {
          year: 2011,
          revenue: [
            ['Ballet and Dance', 4.5],
            ['Children\'s/Family', 4.5],
            ['Classical Music', 4.6],
            ['Festivals (Multi-Category)', 0.8],
            ['Festivals (Contemporary Music)', 7.4],
            ['Musical Theatre', 18.9],
            ['Contemporary Music', 41.3],
            ['Opera', 3.6],
            ['Special Events', 1.2],
            ['Theatre', 5],
            ['Circus and Physical Theatre', 4.3],
            ['Comedy', 4]
          ],
          attendance: [
            ['Ballet and Dance', 5.5],
            ['Children\'s/Family', 8.4],
            ['Classical Music', 6],
            ['Festivals (Multi-Category)', 1.4],
            ['Festivals (Contemporary Music)', 5.7],
            ['Musical Theatre', 16.1],
            ['Contemporary Music', 34.2],
            ['Opera', 2.5],
            ['Special Events', 2.1],
            ['Theatre', 8.0],
            ['Circus and Physical Theatre', 4.2],
            ['Comedy', 5.8]
          ],
        },
      ]
    }
  },
  computed: {
    categoryTrends() {
      const self = this

      for (let i = 0; i < self.reports.length; i++) {
        const report = self.reports[i]
        if (report.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick(e) {
                      e.preventDefault()
                      return false
                    }
                  }
                }
              },
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              formatter(thischart) {
                let category = this.key;
                let chartseries = thischart.chart.series;
                let thisx = this.point.x;
                let thisrevatt = {};
                let tooltipstring = '<strong>' + category + '</strong><br />';

                for (let i = 0; i < chartseries.length; i++) {
                  let series = chartseries[i];
                  for (let j = 0; j < series.points.length; j++) {
                    let point = series.points[j];
                    point.setState();
                  }
                  series.points[thisx].setState('hover');

                  tooltipstring += series.name + ': ' + series.points[thisx].y.toFixed(1) + '%<br />';
                }

                return tooltipstring;
              }
            },
            series: [
              {
                name: 'Revenue Share',
                data: report.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none'
                  },
                  formatter() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                },
                colors: ['#F7977A', '#f5bcab', '#70cb92', '#82CA9D', '#6ECFF6', '#acdff4', '#7EA7D8', '#a1b9d5', '#7068bc',
                  '#8882BE', '#ba74bf', '#BC8DBF', '#F6989D', '#f6c1c4']
              },
              {
                name: 'Attendance Share',
                data: report.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none'
                  },
                  formatter() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                },
                colors: ['#F7977A', '#f5bcab', '#70cb92', '#82CA9D', '#6ECFF6', '#acdff4', '#7EA7D8', '#a1b9d5', '#7068bc',
                  '#8882BE', '#ba74bf', '#BC8DBF', '#F6989D', '#f6c1c4']
              },
            ],
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 400
                },
                chartOptions: {
                  series: [{}, {
                    id: 'versions',
                    dataLabels: {
                      enabled: false
                    }
                  }]
                }
              }]
            }
          }
        }
      }

      return false
    }
  },
}
</script>

<style lang="scss" scoped="scoped">
#category-trends .fullbg {
  background-image: url("~@/assets/img/2025/3-Overview-018-PF-Legends-OTGA-250221-JWyld.jpg");
  background-attachment: scroll;
}

.chart-wrapper {
  position: relative;

  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
